import React from "react"
import { PageHeader } from "react-bootstrap"
import FontAwesome from "react-fontawesome"

export default function CustomPageHeader({ icon, text }) {
  return (
    <PageHeader bsClass="header-container">
      <span className='header-icon'>
        <FontAwesome name={ icon } />
      </span>
      <span className='ml-20'>
        { text }
      </span>
    </PageHeader>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/CustomPageHeader.js